<template>
  <div id="app" ref="app">
    <router-view />

    <!-- <div class="beian">
      <el-button type="primary" @click="test(true)" v-if="!clientFlag"
        >进入房间</el-button
      >

      <el-button type="warning" @click="test(false)" v-else>退出房间</el-button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      clientFlag: false,
      timmer: ''
    }
  },
  methods: {
    test(e) {
      this.clientFlag = e
      this.Bus.$emit('clientLogin', e)
      if (!e) {
        this.$client.loginOut()
      }
    },
    beforeunloadFn(e) {
      this.$chat.ws.close()
    },
    screenTest() {
      var width = document.documentElement.clientWidth
      if (width > 500) {
        this.$router.push({ name: 'login' })
      } else if (width < 500) {
        console.log('横屏')
        this.$router.push({ name: 'mobileTest' })
      }
    }
  },

  beforeCreate() {
    if (localStorage.getItem('locale')) {
      this.$i18n.locale = localStorage.getItem('locale')
    }
  },

  created() {
    this.screenTest()
  },

  destroyed() {}
}
</script>

<style lang="scss" scoped>
html {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;

  overflow: hidden;
}

#layout-container,
#mainrow,
#main-container {
  margin: auto, 0;
  height: 100%;
  width: 100%;
}
.beian {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
  color: #fff;
  width: 500px;
}
</style>
